import Stack from "@mui/material/Stack";
import type { Overwrite } from "@mui/types";
import { theme } from "@polifonia/theme";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import type { ModalProps } from "@/components/Modal";
import { Modal } from "@/components/Modal";
import { Typography } from "@/components/Typography";

namespace DisconnectManagerAccountModal {
  export interface OwnProps {
    open: boolean;
    isLoading: boolean;
    onClose: () => void;
    onConfirm: () => void;
  }

  export type Props = Overwrite<
    Omit<ModalProps, "children" | "handleClose">,
    OwnProps
  >;
}

export const DisconnectManagerAccountModal: React.FC<
  DisconnectManagerAccountModal.Props
> = ({ open, isLoading, onClose, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      handleClose={onClose}
      title={t(
        "applications.googleAds.disconnectManagerAccountModal.title",
        "Disconnect Google Ads?",
      )}
      footer={
        <Stack direction="row" justifyContent="flex-end" gap="12px">
          <Button variant="secondary" onClick={onClose} disabled={isLoading}>
            {t("common.cancel")}
          </Button>
          <Button variant="danger" onClick={onConfirm} loading={isLoading}>
            {t(
              "applications.googleAds.disconnectManagerAccountModal.confirm",
              "Disconnect",
            )}
          </Button>
        </Stack>
      }
    >
      <Stack gap="16px">
        <Typography variant="body" color={theme.colors.staticFgBody}>
          {t(
            "applications.googleAds.disconnectManagerAccountModal.message",
            "This will unbind your Google Ads manager account. All ad accounts, conversion settings, and Conversions tab entries will be removed. This cannot be undone.",
          )}
        </Typography>
      </Stack>
    </Modal>
  );
};
